export default function MgdReportUploadBlock({ clientId, laboratory = 'MGD' }) {
  if (laboratory !== 'MGD' || !clientId) return null;

  return (
    <aside aria-labelledby="mgd-pilot-reception-title" style={styles.card}
      data-testid="mgd-report-upload">
      <div style={styles.headingRow}>
        <div>
          <div style={styles.eyebrow}>Pilote · réception externe</div>
          <h3 id="mgd-pilot-reception-title" style={styles.title}>Utiliser les rapports originaux</h3>
        </div>
        <span style={styles.status}>Aucun stockage</span>
      </div>

      <p style={styles.intro}>
        Pour ce parcours, utilise les PDF originaux dans ta conversation de travail puis reviens coller la synthèse.
      </p>

      <ol style={styles.steps} aria-label="Étapes du pilote">
        <li style={styles.step}><span style={styles.number}>1</span>
          <span><strong>Ouvre ta conversation de travail</strong><small>Depuis ton espace professionnel habituel.</small></span>
        </li>
        <li style={styles.step}><span style={styles.number}>2</span>
          <span><strong>Ajoute les PDF originaux</strong><small>Le SaaS ne reçoit et ne transforme aucun fichier.</small></span>
        </li>
        <li style={styles.step}><span style={styles.number}>3</span>
          <span><strong>Reviens avec la synthèse</strong><small>Tu la colleras à l’étape suivante.</small></span>
        </li>
      </ol>
    </aside>
  );
}

const styles = {
  card: {
    boxSizing: 'border-box', width: '100%', marginTop: 14,
    padding: '20px clamp(16px, 3vw, 26px)', border: '1px solid rgba(45,90,61,.18)',
    borderRadius: 16, background: '#f7f8f3', color: '#203a2a',
  },
  headingRow: {
    display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 14,
  },
  eyebrow: {
    fontSize: 10, fontWeight: 800, letterSpacing: '.12em', textTransform: 'uppercase', color: '#58705d',
  },
  title: { margin: '5px 0 0', fontSize: 20, lineHeight: 1.25 },
  status: {
    flex: '0 0 auto', padding: '5px 9px', borderRadius: 999,
    background: '#e4eee4', color: '#31533a', fontSize: 10, fontWeight: 800,
  },
  intro: {
    maxWidth: 720, margin: '13px 0 17px', fontSize: 14, lineHeight: 1.65, color: '#4e5e53',
  },
  steps: {
    display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
    gap: 9, margin: 0, padding: 0, listStyle: 'none',
  },
  step: {
    display: 'grid', gridTemplateColumns: '30px minmax(0, 1fr)', gap: 9,
    alignItems: 'start', padding: 11, border: '1px solid #d9e0d6', borderRadius: 10,
    background: '#fff', fontSize: 12, lineHeight: 1.4,
  },
  number: {
    display: 'grid', placeItems: 'center', width: 28, height: 28, borderRadius: 8,
    background: '#eaf1e8', color: '#31533a', fontWeight: 850,
  },
};
